import React, { useEffect, useRef, } from 'react'
import { Col, Row } from 'react-bootstrap'
import { FaArrowDownLong, FaArrowUpLong } from 'react-icons/fa6'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

export default function Weboptions(props) {

    const { OptionList, SetOptionList, SelectedOption, SetSelectedOption, hideSubmit } = props

    const handleAddOption = (val) => {
        const isAlreadySelected = SelectedOption.some(option => option.id === val.id);
        if (!isAlreadySelected) {
            SetSelectedOption(prev => [...prev, val]);
            SetOptionList(prev => prev.filter(option => option.id !== val.id));
        }
    };
    const handleRemoveOption = (val) => {
        SetSelectedOption(prev => prev.filter(option => option.id !== val.id));
        SetOptionList(prev => [...prev, val]);
    };
    const handleRowDown = (i) => {
        SetSelectedOption(prevSelectedOption => {
            const newOptions = [...prevSelectedOption]; // Create a new array (spread operator)
            if (i !== newOptions.length - 1) {
                [newOptions[i], newOptions[i + 1]] = [newOptions[i + 1], newOptions[i]];
            }
            return newOptions;
        });
    };
    const handleRowUp = (i) => {
        if (i !== 0) {
            SetSelectedOption(prevSelectedOption => {
                const newOptions = [...prevSelectedOption]; // Create a new array (spread operator)
                [newOptions[i], newOptions[i - 1]] = [newOptions[i - 1], newOptions[i]];
                return newOptions;
            });
        }
    };
    let componentRef = useRef();

    const scrollRef = useRef(null);
    const scrollToBottom = () => {
        if (scrollRef.current && !hideSubmit) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    };
    // Trigger scroll on update when OptionList changes
    useEffect(() => {
        scrollToBottom();
    }, [OptionList]);

    return (
        <Row>

            {!hideSubmit &&
                <Col xs={5}>
                    <div className="table-responsive">
                        <table className="table table-condensed table-bordered" style={{ border: '1px solid skyblue' }}>
                            <thead style={{
                                backgroundColor: '#dbe9f4'
                            }}>
                                <tr>
                                    <th>S.No</th>
                                    <th><span>Post Name </span>: Management Name</th>
                                    <th className='text-center'>+</th>
                                </tr>
                            </thead>
                            <tbody>

                                {OptionList?.map((val, i) =>
                                    <tr key={val.id}>
                                        <td>{i + 1}</td>
                                        <td><b><span style={{ color: 'brown', fontFamily: 'Bold italic' }}>
                                            {val.management_name?.split('_')[0]} </span>: {val.management_name?.split('_')[1]}
                                            <br />{val.management_name?.split('_')[2]}</b></td>
                                        <td>
                                            <button type='button'
                                                //   className={(val.priority === 1 && OptionList?.filter((val4) => val4.priority === 1)?.length !== 0) ||
                                                //       (val.priority === 2 && OptionList?.filter((val3) => val3.priority === 1)?.length === 0) ? "btn btn-xs btn-success" :
                                                //       'btn btn-xs btn-secondary'}
                                                className='btn btn-xs btn-success'
                                                onClick={() => handleAddOption(val)}
                                            >
                                                <FaArrowRight className='float-left' style={{ fontSize: "19px" }} />
                                            </button>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Col>
            }
            <Col xs={7} ref={componentRef}>
                <div className="table-responsive" ref={scrollRef}
                    style={{ overflowY: 'auto', display: 'block', maxHeight: hideSubmit ? "none" : '650px', }}>
                    <table className="table table-condensed table-bordered" id="test-table-xls-button" style={{ border: '1px solid skyblue' }}>
                        <thead style={{ backgroundColor: '#dbe9f4', border: '1px solid skyblue', position: 'sticky', top: 0, zIndex: 1 }}>
                            <tr>
                                <th>Preference</th>
                                <th>Post Name : Management Name</th>
                                {!hideSubmit && (<> <th>-</th>
                                    <th>Up</th>
                                    <th>Down</th>
                                </>)}
                            </tr>
                        </thead>

                        <tbody style={{ color: 'white' }}>
                            {SelectedOption?.map((val, i) => (
                                <tr key={val.id} className='selectedBackground' >
                                    <td className='text-center'>{i + 1}</td>
                                    <td><b><span style={{ color: 'brown', fontFamily: 'Bold italic' }}>
                                        {val.management_name?.split('_')[0]} </span>: {val.management_name?.split('_')[1]}
                                        <br />{val.management_name?.split('_')[2]}</b></td>

                                    {!hideSubmit && (<>
                                        <td>
                                            <button type='button' className="btn btn-xs btn-danger" onClick={() => handleRemoveOption(val)}>
                                                <FaArrowLeft className='float-left' style={{ fontSize: "19px" }} />
                                            </button>

                                        </td>
                                        <td>
                                            {i !== 0 && (<button type='button' onClick={() => handleRowUp(i)}>
                                                <FaArrowUpLong className='float-left' color='black' style={{ fontSize: "19px" }} />
                                            </button>)}
                                        </td>
                                        <td>
                                            {i !== SelectedOption?.length - 1 && (
                                                <button type='button' onClick={() => handleRowDown(i)}>
                                                    <FaArrowDownLong className='float-left' color='black' style={{ fontSize: "19px" }} />
                                                </button>
                                            )}
                                        </td>

                                    </>)}

                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
                {/* {!hideSubmit && (
                    <div className="text-end px-2 mt-2">
                        <button variant="success" type="button" onClick={() => { submitValues() }} className="btn btn-success btn-md">Submit</button>
                    </div>)} */}
            </Col>
            {hideSubmit && <Col xs={3}></Col>}
        </Row>
    );
}
